import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-3cf0a8c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg bg-light shadow sticky-top" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "navbar-brand col-4 col-sm-3 col-lg-2 pe-xl-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-897x263" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_6 = {
  id: "navbarSupportedContent",
  class: "collapse navbar-collapse py-3 py-lg-0"
}
const _hoisted_7 = { class: "navbar-nav text-center align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "nav-item cursor-pointer px-0 px-lg-3 py-2 py-lg-0 justify-content-center"
}
const _hoisted_9 = {
  key: 1,
  class: "nav-item dropdown btn btn-primary rounded-pill ms-2 py-0"
}
const _hoisted_10 = {
  class: "nav-link dropdown-toggle text-white",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_11 = {
  key: 0,
  class: "d-inline"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "dropdown-item text-secondary",
    "data-bs-toggle": "modal",
    "data-bs-target": "#myProfileModal",
    "data-bs-title": "My Profile"
  }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fa fa-user-circle-o",
      "aria-hidden": "true"
    }),
    /*#__PURE__*/_createTextVNode(" My Profile")
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-sign-out",
  "aria-hidden": "true"
}, null, -1))

import { storeToRefs } from "pinia";
import { useClientStore } from "@/store/ClientStore";
import MyProfileModal from "@/components/modals/MyProfileModal.vue";


const __default__ = {
  name: "CustomNavbar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { logoutUser } = useClientStore();
const { clientData, loggedIn } = storeToRefs(useClientStore());

const navItems = [
  { text: "My Projects", link: "Projects", showIfLogged: true },
  { text: "My Credits", link: "Credits", showIfLogged: true },
  { text: "Blog", link: "Blog", showIfLogged: true },
];

function signOut() {
  logoutUser();
  window.location.href = "/sign-in";
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: _unref(loggedIn) ? 'Projects' : 'SignIn' }
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item, i) => {
              return _createElementVNode("li", {
                key: i,
                class: "nav-item cursor-pointer px-0 px-lg-5 py-2 py-lg-0 justify-content-center"
              }, [
                (item.showIfLogged && _unref(loggedIn))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "nav-link p-0",
                      "aria-current": "page",
                      to: { name: item.link }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ])
            }), 64)),
            (!_unref(loggedIn))
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    class: "nav-link p-0 btn btn-info text-white text-decoration-none text-white rounded-pill px-4 py-1",
                    "aria-current": "page",
                    to: { name: 'SignIn' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Sign In ")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_unref(loggedIn))
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    (_unref(clientData))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Welcome, " + _toDisplayString(_unref(clientData).name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("ul", { class: "dropdown-menu position-absolute" }, [
                    _hoisted_12,
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        onClick: signOut,
                        class: "dropdown-item text-secondary",
                        href: "#"
                      }, [
                        _hoisted_13,
                        _createTextVNode(" Sign Out")
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(MyProfileModal)
  ], 64))
}
}

})